import { makeStyles } from '@mui/styles';
import React, { PropsWithChildren } from 'react';

import { SnackbarOpen } from '#app/Action/SnackbarAction';
import { dispatch } from '#app/App';

type Props = {
  value?: string;
};

const CopyOnClick: React.FC<PropsWithChildren<Props>> = ({ value, children }) => {
  const classes = useStyles();
  const handleCopy = () => {
    const textToCopy = value ?? (typeof children === 'string' ? children : '');
    navigator.clipboard.writeText(textToCopy);

    dispatch(
      SnackbarOpen({
        text: `Copié : ${textToCopy}`,
        variant: 'success',
        duration: 1000,
      }),
    );
  };

  return (
    <span onClick={handleCopy} className={classes.cursor}>
      {children}
    </span>
  );
};

const useStyles = makeStyles({
  cursor: { cursor: 'pointer' },
});

export default CopyOnClick;
